export enum RtlEnum{
	rtl,
	ltr
}
